import { createContext, useContext, useEffect, useState } from "react";
import api, { apiError } from "@/lib/api";
import { canWrite, canViewAudit } from "@/lib/perms";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = anon, obj = auth
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("gf_token");
    if (!token) {
      setUser(false);
      setLoading(false);
      return;
    }
    api
      .get("/auth/me")
      .then((res) => setUser(res.data))
      .catch(() => {
        localStorage.removeItem("gf_token");
        setUser(false);
      })
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("gf_token", data.token);
    localStorage.setItem("gf_user", JSON.stringify(data.user));
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("gf_token");
    localStorage.removeItem("gf_user");
    setUser(false);
    window.location.href = "/login";
  };

  const role = user && user.role ? user.role : null;
  const can = (module) => canWrite(role, module);
  const readOnly = !!role && role !== "administrateur" && ["direction", "consultation"].includes(role);

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, role, can, readOnly, canViewAudit: () => canViewAudit(role) }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
export { apiError };
